<template>
    <section class="fin-space-y-4" v-if="fromEmail">
        <el-tabs v-model="activeTab" type="border-card">
            <el-tab-pane label="Email" name="email" class="fin-space-y-4" v-if="showEmail && sendEmail">
                <el-form ref="emailEditor" label-width="140px">
                    <el-form-item label="Subject">
                        <el-input class="fin-w-full" placeholder="Subject" v-model="setSubject"></el-input>
                    </el-form-item>
                    <el-form-item label="Attachments ?">
                        <el-upload
                            id="ticket_multiple_files"
                            ref="upload"
                            class="upload-demo"
                            action="https://jsonplaceholder.typicode.com/posts/"
                            :on-change="onChangeAttachments"
                            :on-remove="removeChangeAttachments"
                            :file-list="files"
                            :auto-upload="false"
                            multiple>
                            <el-button size="small" type="primary">Click to upload</el-button>

                            <div slot="tip" class="el-upload__tip">
                                JPG, JPEG, PNG, CSV, XLX, XLS, or PDF (MAX. 2048).
                            </div>
                        </el-upload>
                    </el-form-item>
                </el-form>

                <editor
                    v-model="setEmailBody"
                    :api-key="apiKey"
                    :init="{
                                        height: 600,
                                        menubar: false,
                                        plugins: [
                                            'advlist autolink link image lists charmap print preview hr pagebreak spellchecker',
                                            'searchreplace wordcount code fullscreen insertdatetime media nonbreaking',
                                            'table directionality emoticons template paste fullpage',
                                        ],
                                        noneditable_editable_class: 'noneditable',
                                        visual: false,
                                        auto_focus: false,
                                        relative_urls: false,
                                        remove_script_host: false,
                                        toolbar:
                                            'undo redo | formatselect | bold italic backcolor | \
                                    alignleft aligncenter alignright alignjustify | \
                                    bullist numlist outdent indent | removeformat',
                                    }"
                ></editor>
            </el-tab-pane>

            <el-tab-pane label="SMS" name="sms" v-if="showSms && sendSms">
                <div class="textarea-word-limit">
                    <div class="textarea-word-limit" v-if="setSmsBody">
                        <div v-if="(smsTextLength > smsTextMaxLength) && smsTemplate"
                             class="text-danger">
                            Error: This text message has exceeded the maximum character limit.
                        </div>

                        <el-input
                            :autosize="{ minRows: 10 }"
                            type="textarea"
                            class="w-100"
                            :class="[{ 'oversize-warning': smsTextLength > smsTextMaxLength }]"
                            v-model="setSmsBody"
                            placeholder="Type message here"
                            show-word-limit
                        ></el-input>
                    </div>
                    <div v-else>
                        <el-tag style="mb-2" type="danger">
                            There isn't a sms template attached to this action. Select a custom Sms Template.
                        </el-tag>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </section>
</template>

<script>
import Editor from "@tinymce/tinymce-vue"
import {mapGetters} from "vuex";

export default {
    name: 'EmailEditor',
    components: {
        Editor
    },
    props: {
        toEmail: {
            required: true,
            type: [String, Object]
        },
        attachmentData: {
            required: false,
            type: [Array, Object]
        },
        isApi: {
            required: true,
        },
        showSms: {
            required: false,
            default: false,
            type: [Boolean]
        },
        showEmail: {
            required: false,
            default: true,
            type: [Boolean]
        }
    },
    data() {
        return {
            activeTab: 'email',
            files: []
        }
    },
    computed: {
        ...mapGetters({
            subject: "ticketEmail/getSubject",
            sendEmail: "ticketEmail/getSendEmail",
            sendSms: "ticketEmail/getSendSms",
            emailTemplate: "ticketEmail/getEmailTemplate",
            smsTemplate: "ticketEmail/getSmsTemplate",
            fromEmail: "ticketEmail/getFromEmail",
            toEmails: "ticketEmail/getToEmails",
            smsTextMaxLength: "ticketEmail/getSmsTextMaxLength",
            emailBody: "ticketEmail/getEmailBody",
            smsBody: "ticketEmail/getSmsBody",
            attachments: "ticketEmail/getAttachments",
        }),
        apiKey() {
            return process.env.MIX_TINY_MCE_API
        },
        setEmailBody: {
            get() {
                return this.emailBody
            },
            set(val) {
                this.$store.dispatch("ticketEmail/setEmailBody", val)
            }
        },
        setSmsBody: {
            get() {
                return this.smsBody
            },
            set(val) {
                this.$store.dispatch("ticketEmail/setSmsBody", val)
            }
        },
        smsTextLength() {
            let smsTextCount = this.setEmailBody.length
            let lineBreakCount = _.size(this.setEmailBody.match(/\n/g) || [])

            return parseInt(smsTextCount) + parseInt(lineBreakCount)
        },
        setSubject: {
            get() {
                return this.subject
            },
            set(val) {
                this.$store.dispatch("ticketEmail/setSubject", val)
            }
        }
    },
    watch: {},
    beforeDestroy() {
        this.$bus.$off('reset-files')
    },
    mounted() {
        this.$bus.$on('reset-files', () => {
            $("#ticket_multiple_files").val('')
            this.$refs.upload.clearFiles()
            this.files = []
            this.$store.dispatch("ticketEmail/setAttachments", [])
        })
    },
    methods: {
        onChangeAttachments(event) {
            this.attachments.push(_.get(event, 'raw'));

            console.warn('attachments ', this.attachments)
        },
        removeChangeAttachments(event) {
            _.remove(this.attachments, function (attachments) {
                return attachments.uid !== _.get(event, 'raw.uid')
            })
        }
    }
}
</script>
